<template>
  <div class="description-create">
    <b-form>
      <b-form-group
        label="標題"
        label-for="one-survey-create-title"
        class="required-icon-star"
      >
        <b-form-input
          id="one-survey-create-title"
          v-model="createForm.title"
          :state="verifyTitle"
          :title="'請輸入值'"
          type="text"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="發布日期" class="required-icon-star">
        <b-form-datepicker
          v-model="createForm.released_at"
          :state="verifyDate"
          :title="'請輸入值'"
          :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          }"
          placeholder="請選擇發布日期"
        >
        </b-form-datepicker>
      </b-form-group>
      <b-form-group label="內容" label-for="one-survey-create-content">
        <editor v-model="createForm.content" :isReadOnly="false"></editor>
      </b-form-group>
    </b-form>
    <div class="text-right">
      <b-button
        class="mr-3"
        type="button"
        variant="primary"
        @click="verifyForm"
        :disabled="isSubmitting"
        >新增</b-button
      >
      <b-button
        class="mr-3"
        type="button"
        variant="dark"
        @click="$router.push({ name: 'WebsiteDescriptions' })"
        >取消</b-button
      >
    </div>
  </div>
</template>

<script>
import mixinsVerify from "@/utility/mixinsVerify.js";
import editor from "@/components/Editor.vue";

export default {
  name: "DescriptionCreate",
  mixins: [mixinsVerify],
  components: {
    editor
  },
  data() {
    return {
      createForm: {
        title: "",
        released_at: "",
        content: ""
      },
      verifyTitle: null,
      verifyDate: null,
      formData: new FormData(),
      isSubmitting: false
    };
  },
  methods: {
    verifyForm() {
      this.verifyTitle = this.hasValue(this.createForm.title);
      this.verifyDate = this.hasValue(this.createForm.released_at);
      if (this.verifyTitle === false || this.verifyDate === false) return;
      else this.submit();
    },
    handleFormData() {
      Object.keys(this.createForm).forEach(key => {
        if (key.includes("released_at")) {
          //from YYYY-MM-DD format to YYYY/MM/DD
          let regex = /-/gi;
          const dateFormat = this.createForm[key].replace(regex, "/");
          this.formData.append(key, dateFormat);
        } else {
          this.formData.append(key, this.createForm[key]);
        }
      });
    },
    async submit() {
      this.handleFormData();
      this.isSubmitting = true;
      await this.$store.dispatch("createDescription", this.formData);
      alert("新增成功");
      this.$router.push({ name: "WebsiteDescriptions" });
    }
  }
};
</script>

<style lang="scss" scoped>
.description-create {
  padding: 1rem;
}
</style>
